export default __webpack_public_path__ + "static/media/FS-TUTORIALES-ICONO-AMARILLO.080bd78e.svg";